import { typography } from 'ms-email/themes/typography'
import { Link, Section } from '@react-email/components'

import { baseUrl } from 'utils'

import { Text } from './Text'

export function WhatIsMapstack() {
  return (
    <Section style={{ marginTop: 32 }}>
      <Text style={typography.h6}>What is Mapstack?</Text>
      <Text
        style={{
          ...typography.body1,
          paddingTop: 10
        }}
      >
        Mapstack is the easiest way to turn your data into insightful, shareable
        maps—helping you and your team uncover trends, make smarter decisions,
        and share powerful visuals effortlessly.{' '}
        <Link
          style={typography.body1}
          href={baseUrl()}
        >
          Learn more about mapstack
        </Link>
        .
      </Text>
    </Section>
  )
}
